import type { IconProps } from "./types";

export function Business({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 2.09961C14.7531 2.09961 15.4849 2.38253 16.0322 2.89941C16.581 3.41787 16.9003 4.13208 16.9004 4.88867V6.09961H19.2002C20.7176 6.09972 21.9004 7.36148 21.9004 8.85742V18.1426C21.9004 19.6385 20.7176 20.9003 19.2002 20.9004H4.7998C3.28242 20.9003 2.09961 19.6385 2.09961 18.1426V8.85742C2.09961 7.36148 3.28242 6.09972 4.7998 6.09961H7.09961V4.88867C7.09967 4.13208 7.41896 3.41787 7.96777 2.89941C8.51506 2.38253 9.24694 2.09961 10 2.09961H14ZM16.9004 19.0996H19.2002C19.6709 19.0995 20.0996 18.6978 20.0996 18.1426V8.85742C20.0996 8.30216 19.6709 7.9005 19.2002 7.90039H16.9004V19.0996ZM8.90039 19.0996H15.0996V7.90039H8.90039V19.0996ZM4.7998 7.90039C4.32913 7.9005 3.90039 8.30216 3.90039 8.85742V18.1426C3.90039 18.6978 4.32913 19.0995 4.7998 19.0996H7.09961V7.90039H4.7998ZM10 3.90039C9.69219 3.90039 9.40696 4.01642 9.2041 4.20801C9.00307 4.39789 8.90045 4.64363 8.90039 4.88867V6.09961H15.0996V4.88867C15.0995 4.64363 14.9969 4.39789 14.7959 4.20801C14.6184 4.04036 14.3779 3.93009 14.1143 3.90527L14 3.90039H10Z"
        fill={currentColor}
      />
    </svg>
  );
}
